import * as React from 'react';
import type { DefinedTerm, WithContext } from 'schema-dts';

import type { SanityGlossaryTerm } from '#/lib/sanity/queries/glossaryTerm';
import { blocksToText } from '#/lib/sanity/utils';

import { RenderSEOSchema } from './Render';

export function GlossaryTermSchema({
  title,
  href,
  description,
  definition,
}: SanityGlossaryTerm) {
  const schemaData: WithContext<DefinedTerm> = {
    '@context': 'https://schema.org',
    '@type': 'DefinedTerm',
    name: title,
    url: `https://transcend.io${href}`,
    description: description ?? blocksToText(definition),
    inDefinedTermSet: {
      '@type': 'DefinedTermSet',
      name: 'Transcend Privacy Glossary',
      url: 'https://transcend.io/glossary',
    },
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
